const GET_ITEM_NAMES = 'app/items/GET_ITEM_NAMES';
const SET_ITEM_NAMES = 'app/items/SET_ITEM_NAMES';
const GET_ITEM_CATEGORIES = 'app/items/GET_ITEM_CATEGORIES';
const SET_ITEM_CATEGORIES = 'app/items/SET_ITEM_CATEGORIES';
const GET_STATES = 'app/items/GET_STATES';
const SET_STATES = 'app/items/SET_STATES';
const GET_LICENSE_NUMBERS = 'app/items/GET_LICENSE_NUMBERS';
const SET_LICENSE_NUMBERS = 'app/items/SET_LICENSE_NUMBERS';
const GET_QUANTITY_TYPES = 'app/items/GET_QUANTITY_TYPES';
const SET_QUANTITY_TYPES = 'app/items/SET_QUANTITY_TYPES';
const GET_PACKAGE_IDS = 'app/items/GET_PACKAGE_IDS';
const SET_PACKAGE_IDS = 'app/items/SET_PACKAGE_IDS';

export {
  GET_ITEM_NAMES,
  SET_ITEM_NAMES,
  GET_ITEM_CATEGORIES,
  SET_ITEM_CATEGORIES,
  GET_STATES,
  SET_STATES,
  GET_LICENSE_NUMBERS,
  SET_LICENSE_NUMBERS,
  GET_QUANTITY_TYPES,
  SET_QUANTITY_TYPES,
  GET_PACKAGE_IDS,
  SET_PACKAGE_IDS,
};
